import { Box, Skeleton, useTheme } from "@mui/material";
import type { FC } from "react";
import { useChatAttachmentImage } from "web_myplann/Api/Chat/useChatAttachmentImage";

type Props = {
	attachmentId?: number;
	fileName: string;
	localUrl?: string;
};

const MAX_HEIGHT = 240;

export const ChatAttachmentImage: FC<Props> = ({
	attachmentId,
	fileName,
	localUrl,
}) => {
	const theme = useTheme();
	const isUploaded = attachmentId !== undefined;
	const { url: fetchedUrl } = useChatAttachmentImage(
		attachmentId,
		isUploaded && localUrl === undefined,
	);
	const url = localUrl ?? fetchedUrl;

	if (!url) {
		return (
			<Skeleton
				variant="rounded"
				width={180}
				height={180}
				sx={{ borderRadius: theme.radii.xl }}
			/>
		);
	}

	return (
		<Box
			component="img"
			src={url}
			alt={fileName}
			display="block"
			maxWidth="100%"
			maxHeight={MAX_HEIGHT}
			borderRadius={theme.radii.xl}
			sx={{ objectFit: "cover" }}
		/>
	);
};
